import {connect} from 'react-redux';
import {Component} from 'react';
import Helmet from 'react-helmet';

import {fbPixelScript, fbPixelNoScript} from '-/util/facebookPixel';
import {AppSteps} from '-/components/general/AppData';
import config from '-/config/config';

const {appTitle} = config;


class Head extends Component {
    render() {
        const {creditorName = '', currentStep} = this.props;
        const {title = creditorName} = AppSteps[currentStep];

        return (
            <Helmet>
                <title>{title && `${title} - `}{appTitle}</title>
                <script>{fbPixelScript}</script>
                <noscript>{fbPixelNoScript}</noscript>
            </Helmet>
        );
    }
}

const mapStateToProps = (state) => {
    const {creditor, navigation} = state;
    const {currentStep} = navigation;
    const {name: creditorName} = creditor;
    return {
        creditorName,
        currentStep
    };
};

export default connect(mapStateToProps)(Head);
